import React from 'react';
import { get } from '../../util/api';
import _ from 'lodash';
import { CopyToClipboard } from 'react-copy-to-clipboard';
// eslint-disable-next-line
import styled from 'styled-components/macro';
import { Box, Button, Switch, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import DirectionsIcon from '@mui/icons-material/Directions';

const RefreshBtn = (props) => {
	const [loading, setLoading] = React.useState(false);
	function onclick() {
		setLoading(true);
		get('/maytapi/refreshSubscription/' + props.uid).then(() => {
			setLoading(false);
		});
	}

	return (
		<Button onClick={onclick} loading={loading}>
			<RefreshIcon />
		</Button>
	);
};

export default function Footprint() {
	const [loading, setLoading] = React.useState(true);
	const [data, setData] = React.useState({});
	const [onlysubs, setOnlySubs] = React.useState(true);
	const [hideFree, sethideFree] = React.useState(false);
	const [multiInstance, setMultiInstance] = React.useState(false);

	React.useEffect(() => {
		get('/maytapi/admin/phoneList?type=missed').then((temp) => {
			setLoading(false);
			const { phones, products } = temp;
			const map_pro = {},
				sub_pro = {};
			_.each(products, (it) => {
				map_pro[it.id] = it;
				if (it.sub)
					if (sub_pro[it.id]) sub_pro[it.id].push(it.sub);
					else sub_pro[it.id] = [it.sub];
			});
			let new_list = [];
			_.each(phones, (it) => {
				_.each(it.phone_ids_json, (o) => {
					console.log('---o', o);
					let _o = {
						pid: it.pid,
						token: it.token,
						...o,
					};
					new_list.push(_o);
				});
			});
			console.log('new_list', new_list);
			setData({
				list: _.orderBy(
					_.map(_.filter(phones, { type: 'whatsapp' }), (it) => {
						it.product = map_pro[it.pid];
						it.sub = sub_pro[it.pid];
						it.subscription = it.product &&
							it.product.settings &&
							it.product.settings.subscription_package && [
								it.product.settings.subscription_package,
								it.product.settings.phone_limit,
								it.product.settings.agent_limit,
								it.product.settings.instagram_limit,
							];
						let token = (it.product && it.product.settings && it.product.settings.wapi_token) || temp.token;
						it.url = `https://api.maytapi.com/api/${it.pid}/${it.id}/screen?token=${token}`;
						it.backupUrl = `https://api.maytapi.com/api/${it.pid}/${it.id}/backup_start?token=${token}`;
						it.token = token;
						it.copy_text = JSON.stringify(it, null, 2);
						return it;
					}),
					'id'
				),
				new_list,
				products,
			});
		});
	}, []);
	if (loading) return <Box attached="bottom">loading...</Box>;

	const { column, list, direction, new_list, products } = data;
	function handleSort(clickedColumn) {
		return () => {
			if (column !== clickedColumn) {
				setData({
					column: clickedColumn,
					list: _.sortBy(list, [clickedColumn]),
					direction: 'ascending',
				});

				return;
			}

			setData({
				column: clickedColumn,
				list: list.reverse(),
				direction: direction === 'ascending' ? 'descending' : 'ascending',
			});
		};
	}
	let filteredlist = list;
	console.log(filteredlist);
	if (onlysubs) {
		filteredlist = _.filter(list, (it) => it.subscription);
	}
	if (multiInstance) {
		filteredlist = _.filter(list, (it) => it.sessionId);
	}
	if (hideFree) {
		filteredlist = _.filter(list, (it) => it.sessionId !== 'free');
	}
	console.log('products', products);
	return (
		<Box attached="bottom">
			{/* <label>Multi-Instance</label>
			<Switch toggle name="multiInstance" checked={multiInstance} onClick={() => setMultiInstance(!multiInstance)} /> */}

			<Table sortable celled>
				<TableHead>
					<TableRow>
						<TableCell>#</TableCell>
						<TableCell textAlign="center" style={{ width: 70 }} collapsing sorted={column === 'id' ? direction : null} onClick={handleSort('id')}>
							ID
						</TableCell>
						<TableCell sorted={column === 'pid' ? direction : null} onClick={handleSort('pid')}>
							Product
						</TableCell>
						<TableCell sorted={column === 'subscription' ? direction : null} onClick={handleSort('subscription')}>
							Subscription
						</TableCell>
						<TableCell sorted={column === 'status' ? direction : null} onClick={handleSort('status')}>
							Status
						</TableCell>
						<TableCell>Number</TableCell>
						<TableCell>Refresh Sub</TableCell>
						<TableCell>Backup Start</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{_.map(new_list, (it, i) => {
						let { phone_id, pid, token, number, auth, status, subscription, copy_text } = it;
						//console.log(subscription);
						let screen_url = `https://api.maytapi.com/api/${pid}/${phone_id}/screen?token=${token}`;
						let back_url = `https://api.maytapi.com/api/${pid}/${phone_id}/backup_start?token=${token}`;
						let product = _.find(products, (it) => it.id === pid);
						console.log('prrr', product);
						return (
							<TableRow key={phone_id}>
								<TableCell>{i + 1}</TableCell>
								<TableCell textAlign="center">
									<CopyToClipboard text={copy_text}>
										<span>
											{phone_id}
											<a href={screen_url} target="_blank" rel="noopener noreferrer">
												<DirectionsIcon />
											</a>
										</span>
									</CopyToClipboard>
								</TableCell>
								<TableCell>
									{product ? (
										<a href={'/yta/logs?uid=' + product.uid} target="_blank" rel="noopener noreferrer">
											{product.email}
										</a>
									) : (
										pid
									)}
								</TableCell>

								<TableCell>
									{product.settings && (
										<div>
											{product.settings.subscription_package || 'null'} - [{'P:' + product.settings.phone_limit || 0},
											{'A:' + product.settings.agent_limit || 0}, ]
										</div>
									)}
								</TableCell>
								<TableCell>
									{status}
									{it.sessionId ? ` [${it.sessionId}]` : ''}
								</TableCell>
								<TableCell>{(number || auth) && `${number}, ${auth}`}</TableCell>

								<TableCell>{product && product.uid && <RefreshBtn uid={product.uid} />}</TableCell>

								<TableCell>
									<span>
										<a href={back_url} target="_blank" rel="noopener noreferrer">
											<DirectionsIcon />
										</a>
									</span>
								</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</Box>
	);
}
